'use es6';

import { jsx as _jsx } from "react/jsx-runtime";

const StopPropagationWrapper = ({
  className,
  children
}) => /*#__PURE__*/_jsx("span", {
  onClick: e => e && e.stopPropagation(),
  role: "presentation",
  className: className,
  children: children
});

export default StopPropagationWrapper;